import Vue from 'vue'
import App from './App.vue'

const config = require('./config')
// console.log(config)
Vue.prototype.$config = config

// 添加碎片切换音效
// Vue.prototype.$yinxiao = {}
// const yinxiaoNames = ['风铃', '韩剧片头', '静谧ipad', '清脆iphone', '吐泡泡']
// yinxiaoNames.forEach((item, index) => {
//   const audioE = document.createElement('audio')
//   audioE.preload = 'preload'
//   audioE.src = config.publicPath + 'media/' + item + '.mp3'

//   Vue.prototype.$yinxiao[index] = audioE
// })

Vue.config.productionTip = false

// 预加载图片，资源


new Vue({
  render: h => h(App),
}).$mount('#app')
